import { FC, HTMLAttributes } from 'react';

import { cn } from '@/utils/tailwind';

type DatePickerItemProps = HTMLAttributes<HTMLButtonElement> & {
  isActive?: boolean;
};

export const DatePickerItem: FC<DatePickerItemProps> = ({
  children,
  isActive,
  className,
  ...props
}) => {
  return (
    <button
      className={cn(
        'cursor-pointer rounded-[6px] px-4 py-2.5 text-body-14-medium transition-colors',
        isActive
          ? 'bg-custom-warm-grey-100 text-custom-cyan-500 hover:bg-custom-warm-grey-150 focus:bg-custom-warm-grey-200'
          : 'bg-transparent text-custom-warm-grey-700 hover:bg-custom-warm-grey-100 focus:bg-custom-warm-grey-150',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};
